import $ from 'jquery';
window.$ = $;
window.jQuery = $;


import 'bootstrap';
import '@ungap/custom-elements';

import 'jquery-ajax-unobtrusive';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

// Enable tooltips
import Tooltip from "bootstrap/js/dist/tooltip";

const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
tooltipTriggerList.map((elem) => {
  return new Tooltip(elem);
});

import SiteHeader from "./js/components/SiteHeader";
import StationsMap from "./js/components/StationsMap";
import TextSlider from "./js/components/TextSlider";
import Avis from "./js/components/Avis";
import Tarifs from "./js/components/Tarifs";
import Vote from "./js/components/Vote";
import CardVideoFullwidth from "./js/components/CardVideoFullwidth";
import CardVideo from "./js/components/CardVideo";
import IntlTelInput from "./js/components/IntlTelInput";
import Inscription from "./js/components/Inscription";
import InscriptionSummary from "./js/components/InscriptionSummary";
import CardComment from "./js/components/CardComment";
import SimulateurDeplacements from "./js/components/SimulateurDeplacements";
import FormQuizVoiture2 from "./js/components/FormQuizVoiture2";
import FormQuizVoiture8 from "./js/components/FormQuizVoiture8";
import QuantitySelector from "./js/components/QuantitySelector";

// Define css variable used for css fullwidth features
window.addEventListener("DOMContentLoaded", (e) => {

    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    document.body.style.setProperty("--scrollbarWidth", `${scrollbarWidth}px`);

    // Custom elements
   
    customElements.define("card-comment", CardComment, { extends: "div" });
    customElements.define("site-header", SiteHeader);
    customElements.define("stations-map", StationsMap);
    customElements.define("text-slider", TextSlider);
    customElements.define("avis-mount", Avis);
    customElements.define("tarifs-mount", Tarifs);
    customElements.define("vote-mount", Vote);
    customElements.define("card-video-fullwidth", CardVideoFullwidth, { extends: 'div' });
    customElements.define("card-video", CardVideo, { extends: 'div' });
    customElements.define("intl-tel-input", IntlTelInput, { extends: 'div' });
    customElements.define("inscription-mount", Inscription, { extends: 'div' });
    customElements.define("inscription-summary", InscriptionSummary, { extends: 'div' });
    customElements.define("simulateur-deplacements", SimulateurDeplacements);
    customElements.define("form-quiz-voiture-2", FormQuizVoiture2, { extends: "div" });
    customElements.define("form-quiz-voiture-8", FormQuizVoiture8, { extends: "div" });
    customElements.define("quantity-selector", QuantitySelector);

})

import './scss/main.scss';
